import { createAction, props } from '@ngrx/store';
import { Group } from '../../model/group.model';

/**
 * Actions pour la gestion des groupes (permissions)
 */

// Load Groups
export const LoadGroups = createAction(
    '[Group] Load Groups'
);

export const LoadGroupsSuccess = createAction(
    '[Group] Load Groups Success',
    props<{ groups: Group[] }>()
);

export const LoadGroupsFailure = createAction(
    '[Group] Load Groups Failure',
    props<{ error: string }>()
);
